import { render, staticRenderFns } from "./buyer-review.vue?vue&type=template&id=59be9c16&scoped=true&"
import script from "./buyer-review.vue?vue&type=script&lang=js&"
export * from "./buyer-review.vue?vue&type=script&lang=js&"
import style0 from "./buyer-review.vue?vue&type=style&index=0&id=59be9c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be9c16",
  null
  
)

export default component.exports